import React from "react"
import { Layout } from "../components/layout"
import SEO from "../components/seo"
import { Link, graphql } from "gatsby"
import { linkResolver } from '../utils/linkResolver'
import Img from "gatsby-image"

export const query = graphql`
query timelineQuery {
    prismic {
      allPosts(sortBy: meta_firstPublicationDate_ASC) {
        edges {
          node {
            _meta{
                type
                uid
              }
            title
            timespan
            image
            imageSharp {
              childImageSharp {
                fluid(quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
              }
            }
          }
        }
      }
    }
  }
`
const timelinePage = ({ data }) => (
  <div className="body">
    <Layout>
      <SEO title="Timeline" />
      <div className="grid-child intro">
        <div className="text-wrapper">
          <h1>Timeline.</h1>
          <p className="page-paragraph"><strong>‍</strong>I found that the most cohesive way to tie everything together was to document my internship by writing a summary of each week. These timeline posts were written mostly in hindsight and generated from my journal entries, a detailed timesheet, and any relevant screenshots/media. <br /></p>
          <p className="page-paragraph">They will generally follow the following format: Number of internship hours that week, a brief outline of what I spent time working on, and the relevant tags for themes and tools with brief thoughts in those areas.</p>
        </div>
      </div>
      <div className="grid-child nopadding">
        <div className="card-parent grid">
          {data.prismic.allPosts.edges.map(({ node: post }, i) => (
            <Link to={linkResolver(post._meta)} key={i} className="no-decoration">
              <div className="card ingrid w-inline-block">
                <div className="card-label">
                  <h4 className="card-title">{post.title[0].text}</h4>
                  <div>{post.timespan[0].text}</div>
                </div>
                <div className="card-image">
                  <Img fluid={post.imageSharp.childImageSharp.fluid} className="image" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  </div>
)
export default timelinePage